import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const CartService = {
  getAllCartItems,
  addToCart,
  removeFromCart,
  getCartSummary,
  getCheckoutItems,
  saveForLater,
  getSavedItemsForUser,
  removeSavedItem,

};

async function addToCart(cartItem) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: cartItem,
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/cart/add-to-cart`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllCartItems(user_id) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/assessment-subscription/cart/get-cart-items/${user_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function saveForLater(cartItem) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: cartItem,
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/cart-items/save-for-later`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function removeFromCart(cartItem) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: cartItem,
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/cart-items/remove-from-cart`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getSavedItemsForUser(user_id) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/saved-later-items/get-saved-items/${user_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function removeSavedItem(saved_later_item_id) {
    const requestOptions = {
        method: "DELETE",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/saved-later-items/remove-saved-item/${saved_later_item_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getCartSummary(user_id) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/cart/get-cart-summary/${user_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getCheckoutItems(payloadData) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payloadData),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/cart/checkout-amount-purchase`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}